import { ChangeEvent, useState } from 'react';
import Button from '../../../juristec-ui/core/Button';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import InputTextLine from '../../../juristec-ui/core/InputTextLine';

import { Send } from '../../../juristec-ui/icons';
import { verifyEmail } from '../../../juristec-ui/utils/validators/inputTextValidators';
import { MainContainer, InputRow, ActualEmailContainer } from './styled';

interface AdminUserEmail {
  email: string;
  hide: () => void;
  sendEmailVerification: () => void;
  submitNewEmail: (newEmail: string) => void;
}

interface NewEmailState {
  value: string;
  error: boolean;
  errorMsg: string;
}

const AdminUserEmail = ({
  email,
  hide,
  sendEmailVerification,
  submitNewEmail,
}: AdminUserEmail) => {
  const [newEmail, setNewEmail] = useState<NewEmailState>({ value: '', error: true, errorMsg: '' });

  const handleNewEmail = (e: ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.trim();
    const msg = verifyEmail(val, true);
    setNewEmail({
      value: val,
      error: msg.length !== 0,
      errorMsg: msg,
    });
  };

  const handleSubmit = () => {
    submitNewEmail(newEmail.value);
  };

  return (
    <>
      <MainContainer>
        <ActualEmailContainer>
          <div>
            <h3>E-mail atual</h3>
            <span>{email}</span>
          </div>
          <Button
            style={{
              maxWidth: '300px',
              margin: '0 auto',
              padding: '2px 4px ',
              whiteSpace: 'nowrap',
            }}
            size="small"
            textTransform="none"
            onClick={sendEmailVerification}
          >
            Verificar e-mail
            <Send />
          </Button>
        </ActualEmailContainer>
        <InputRow>
          <InputTextLine
            label="Novo e-mail"
            name="email"
            errorMessage={newEmail.errorMsg}
            error={newEmail.errorMsg.length > 0}
            onChange={handleNewEmail}
            value={newEmail.value}
            setValue={() => {}}
          />
        </InputRow>
      </MainContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={hide}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={newEmail.error}
        >
          Alterar
        </Button>
      </ActionsGroup>
    </>
  );
};

export default AdminUserEmail;
